import React from 'react';

const UdemyLogo = () => {
  return (
    <div>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='180'
        height='180'
        viewBox='0 0 113 32'
        style={{
          position: 'absolute',
          maxWidth: '100%',
          maxHeight: '100%',
          top: '0',
          bottom: '0',
          left: '0',
          right: '0',
          margin: 'auto',
          borderRadius: '50%',
        }}
      >
        <title>Logo@2x</title>
        <g fill='none' fill-rule='evenodd'>
          <path
            d='M47 17.77V9.886h3.387v7.822c0 2.81 1.26 3.387 2.995 3.387 1.88 0 2.851-.826 2.851-3.387V9.886h3.408v7.884c0 4.647-2.024 6.59-6.424 6.59-4.09 0-6.217-1.674-6.217-6.59zm22.049 5.515c-.847.64-1.818 1.033-3.202 1.033-2.912 0-5.019-1.797-5.019-5.495 0-3.676 2.417-5.66 5.515-5.66.723 0 1.425.104 2.066.352V9h3.263v15.07h-2.065l-.558-.785zm-2.52-1.756c.744 0 1.301-.124 1.88-.557v-4.627c-.517-.31-1.033-.455-1.777-.455-1.59 0-2.5 1.074-2.5 2.871 0 1.756.93 2.768 2.397 2.768zm12.039 2.747c-3.14 0-5.66-1.549-5.66-5.639 0-3.82 2.438-5.473 5.247-5.473 3.387 0 4.895 2.375 4.895 6.114h-6.837c.227 1.838 1.363 2.375 2.871 2.375 1.26 0 2.376-.289 3.305-.847l-.454 2.603c-.847.599-1.921.867-3.367.867zm-2.334-6.568h4.193c-.227-1.384-.971-2.045-2.087-2.045-.95 0-1.858.558-2.106 2.045zm11.382-.909v7.271h-3.264V13.432h2.293l.682.93c.888-.744 1.838-1.178 2.933-1.178 1.466 0 2.582.434 3.263 1.508.992-.909 2.045-1.508 3.388-1.508 2.52 0 3.987 1.302 3.987 4.834v6.052h-3.264v-5.68c0-1.632-.661-2.107-1.715-2.107-.62 0-1.136.165-1.714.537.041.372.062.764.062 1.198v6.052h-3.264v-5.68c0-1.632-.66-2.107-1.735-2.107-.599 0-1.094.144-1.652.516zm16.15 10.817h3.236l5.596-14.184h-3.201l-2.314 7.065-2.437-7.065h-3.574l4.255 10.245-1.56 3.939z'
            fill='#fff'
          />
          <path
            d='M38.321 18.237a1.09 1.09 0 0 0-.455-.218c-.986.99-2.197 2.03-3.267 2.731-.497.33-1.12.492-1.533.492-.951 0-1.357-.906-1.483-2.352-.168-1.938-.273-4.256-.273-7.844 0-3.68-.833-6.18-3.051-6.376a3.739 3.739 0 0 0-.287-.014c-1.357 0-2.022.702-2.883 2.471-.741 1.524-1.896 3.75-4.037 7.957-1.855 3.63-3.919 6.846-5.69 9.072-.496.618-.88 1.04-1.252 1.285-.245.162-.482.246-.727.246-.7 0-1.21-.59-1.379-1.973a8.915 8.915 0 0 1-.063-1.117c0-2.844 1.07-7.464 2.925-14.269C16.224 3.378 15.65 0 12.683 0h-.035c-.672.007-1.232.253-1.763.674-.532.414-1.057 1.32-1.554 2.535-.56 1.37-3.94 8.18-9.327 11.692-.063 1.334.685 2.668 2.218 2.816 1.385.133 2.372-.457 3.645-1.313-.098.428-.181.821-.265 1.187-.098.428-.175.8-.238 1.102-.098.442-.161.73-.175.815a23.83 23.83 0 0 0-.385 2.317C4.04 28.636 7.19 32 10.878 32c.615 0 1.224-.077 1.833-.232 4.058-1.032 7.97-5.709 12.595-16.467a30.46 30.46 0 0 0-.028 3.28c.308 6.165 2.736 8.019 6.172 8.019 2.596 0 5.03-1.362 6.27-3.048.91-1.193 1.28-2.514 1.28-3.546-.028-.8-.28-1.44-.679-1.77z'
            fill-rule='nonzero'
            fill='#fff'
          />
        </g>
      </svg>
    </div>
  );
};

export default UdemyLogo;
